namespace $.$$ {
	$mol_style_define( $shm_hitalama_guide_panel, {
		Page: { width: '48rem', minWidth: 0, flex: { basis: '48rem', grow: 0, shrink: 0 }, background: { color: $mol_theme.back }, Title: { padding: 0, alignItems: 'center' } },
		Header_title: { alignItems: 'center', minWidth: 0, overflow: 'hidden', whiteSpace: 'nowrap', flex: { shrink: 1 } },
		Header_label: { padding: $mol_gap.text },
		Crumb: { minWidth: 0, whiteSpace: 'nowrap', overflow: 'hidden', flex: { shrink: 1 } },
	})
}
